// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__1n43L","axisTick":"styles_axisTick__3ed--"};